import { getValueFromPermalink } from '@/../shared/utils/utils'

export default {
  methods: {
    removableRefinements (items) {
      return items.filter(item => item.refinements.some(this.canFilterRefinementBeRemoved))
    },
    canFilterRefinementBeRemoved ({ attribute, value }) {
      let isHolidayCollection = this.$route.name === 'holiday-collection'
      let permalink = this.$route.params.name
      let isCategory = /^category\.lvl\d/.test(attribute)
      let isRootCategory = permalink && this.isCategoryPage && value === getValueFromPermalink(permalink)
      let isHolidayRootCategory = isHolidayCollection && isCategory && value === 'holiday'

      if (isHolidayRootCategory) return false

      return !isCategory || !isRootCategory
    }
  }
}